import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import List from "../../styledComponents/Table/List";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import "../IncomeDashboard.css";
import { Table } from "antd";

export const IncomeTable = ({
  data,
  deletePost,
  page,
  setCurrentPage,
  totalPages,
}) => {
  const history = useHistory();

  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const report_cols = [
    {
      title: "Type of Income",
      dataIndex: "module",
      key: "module",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Income Name",
      dataIndex: "Income Name",
      key: "Income Name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Gross Amount",
      dataIndex: "Gross Monthly Wages",
      key: "Gross Monthly Wages",
      render: (record) =>
        record
          ? !isNaN(record)
            ? `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Active/Passive",
      dataIndex: "Passive or Active",
      key: "Passive or Active",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Frequency",
      dataIndex: "Frequency of Pay Periods",
      key: "Frequency of Pay Periods",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        fnEdit(record);
                        setDropdown(false);
                      }}
                    >
                      Update
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        deletePost(record.id);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const fnEdit = (record) => {
    history.push(`/income_new/attributes/${record.module}/${record.id}`);
  };
  const fnView = (record) => {
    history.push(`/income_new/attributes/${record.module}/${record.id}/view`);
  };

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };

  return (
    <React.Fragment>
      <div className="incomeInfoMaincard">
        <h3 className="incomecardheading">All Income</h3>
        {/*<List cols={report_cols} rows={data} /> */}
        <Table
          columns={report_cols}
          dataSource={data}
          pagination={{
            total: totalPages * 10, // Assuming 10 items per page
            current: page,
            onChange: (page) => {
              setCurrentPage(page);
            },
            pageSize: 10, // Number of items per page
          }}
        />
      </div>
    </React.Fragment>
  );
};
